import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import styles from "./buyStack.module.css";
import { getStacksList, addNewBuyStack } from "../../api";
import { validateForm } from "../../utils/validation";
import StackBuyForm from "./StackBuyForm";

const NewStackBuy = ({ custId, newStackAdded, setShowModal }) => {
  const [formData, setFormData] = useState({
    ticker: "",
    amount: "",
    comment: "",
  });
  const [errors, setErrors] = useState({});
  const [showStackDropDown, setShowStackDropDown] = useState(false);
  const [selectedStack, setSelectedStack] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [stacks, setStacks] = useState([]);
  const [noUserError, setNoUserError] = useState("");
  const [initialLoading, setInitialLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setInitialLoading(true);
    const stacksList = async () => {
      try {
        const response = await getStacksList(custId);
        if (response.code === 200) {
          setStacks(response.data);
        } else {
          setNoUserError(response?.data?.message || "Something went wrong!");
        }
      } catch (error) {
        setNoUserError(error?.message || "Something went wrong!");
      } finally {
        setInitialLoading(false);
      }
    };
    stacksList();
  }, [custId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDropDownSelect = (item) => {
    setSelectedStack(item);
    setFormData({ ...formData, ticker: item });
    setShowStackDropDown(false);
  };

  const requiredFields = ["ticker", "amount", "comment"];
  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentStack = stacks.find(
      (stack) => stack.ticker === formData.ticker
    );
   
    if (validateForm(requiredFields, setErrors, formData, currentStack)) {
      setSubmitting(true);
      try {
        const response = await addNewBuyStack(custId, {
          ...formData,
          side: "BUY",
          category: "stack",
          type: "MARKET",
        });

        setFormData({
          ticker: "",
          amount: "",
          comment: "",
          side: "",
          category: "",
          type: "",
        });
        setSelectedStack("");
        setErrors({});
        setSuccessMessage("Stack added successfully");
        newStackAdded();
        setTimeout(() => {
          setShowModal(false);
          setSuccessMessage("");
        }, 4000);

      } catch (error) {
        console.error("Error adding stack:", error);
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <div className={styles.formContainer}>
      {!initialLoading ? (
        <>
          {noUserError ? (
            <div className={styles.errorContainer}>
              <p className={styles.apiError}>{noUserError}</p>
            </div>
          ) : (
            <StackBuyForm
              formData={formData}
              errors={errors}
              stacks={stacks}
              selectedStack={selectedStack}
              handleChange={handleChange}
              handleDropDownSelect={handleDropDownSelect}
              handleSubmit={handleSubmit}
              showStackDropDown={showStackDropDown}
              setShowStackDropDown={setShowStackDropDown}
              successMessage={successMessage}
              loading={submitting}
              disabled={submitting}
            />
          )}
        </>
      ) : (
        <Spinner animation="border" className={styles.spinnerColor} />
      )}
    </div>
  );
};

export default NewStackBuy;
